import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { mutationKeys } from '../mutationKeys';
import { EmailTemplateRecipientsType } from '../../../types/EmailTemplate';

type SendEmailsParams = {
  eventEmailTemplateUuid: string;
  recipientType: EmailTemplateRecipientsType;
  recipientUuids: string[];
};

export const sendEmails = async ({ eventEmailTemplateUuid, recipientType, recipientUuids }: SendEmailsParams): Promise<{ success: boolean }> => {
  const response = await CustomAxios.post(`event_email_templates/${eventEmailTemplateUuid}/send_emails`, {
    recipient_type: recipientType,
    recipient_uuids: recipientUuids,
  });
  const { data } = response;
  return data;
};

type useSendEmailsProps = {
  onSuccessCallback?: () => void;
};

export function useSendEmails({ onSuccessCallback }: useSendEmailsProps = {}) {
  return useMutation({
    mutationKey: [mutationKeys.sendEmails],
    mutationFn: sendEmails,
    onSuccess: () => {
      if (onSuccessCallback) onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      console.error('Failed to send emails:', err.response?.data || err.message);
    },
  });
}
